<template>
  <div class="flex-1 flex-col w-full">
    <global-wrapper
      :loading="$apollo.queries.detailBidang.loading"
      :loadingType="'CardShow'"
    >
      <vx-card v-if="!$apollo.queries.detailBidang.loading">
        <template slot="no-body">
          <global-header :buttonBack="true" :actions="false">
            <template
              slot="actions-custom"
              v-if="!$apollo.queries.detailBidang.loading"
            >
              <vs-button
                type="border"
                color="primary"
                icon-pack="feather"
                icon="icon-edit"
                @click="$refs.dialogUpdate.toggleActive(true)"
                ><div class="hidden sm:block">Edit</div>
              </vs-button>
            </template>
          </global-header>
          <div class="w-full flex flex-col p-5 pt-0">
            <div class="w-full flex flex-col">
              <div class="font-bold">Nama Bidang :</div>
              <div>{{ detailBidang.nama }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Instansi :</div>
              <div>{{ detailBidang.instansi.nama }}</div>
            </div>
          </div>
        </template>
      </vx-card>
    </global-wrapper>
    <DialogUpdate
      ref="dialogUpdate"
      :bidang="detailBidang"
      @submitCallback="refreshBidangQuery()"
    />
  </div>
</template>

<script>
import { GET_DETAIL } from "@/query/bidang";
import DialogUpdate from "./DialogUpdate";

export default {
  components: {
    DialogUpdate
  },
  data() {
    return {
      detailBidang: {}
    };
  },
  apollo: {
    detailBidang: {
      query: GET_DETAIL,
      update: data => data.bidangByUuid,
      variables() {
        return {
          id: this.$route.params.uuid
        };
      }
    },
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Detail Bidang");
  },
  methods: {
    refreshBidangQuery() {
      this.$apollo.queries.detailBidang.refetch();
    }
  }
};
</script>
